export enum HttpStatusCode {
    NotFound = 404,
    Ok = 200,
}
